export default "<p>suporte works!</p>\n"